"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragHandle = exports.DragHandleDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var lodash_1 = require("lodash");
exports.DragHandleDefaultProps = {
  dots: 3,
  isDragging: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-right: none;\n    display: flex;\n    flex-direction: column;\n    height: ", ";\n    width: ", ";\n    cursor: grab;\n    align-items: center;\n    justify-content: center;\n    background: #FFF;\n\n  "], ["\n    border-right: none;\n    display: flex;\n    flex-direction: column;\n    height: ", ";\n    width: ", ";\n    cursor: grab;\n    align-items: center;\n    justify-content: center;\n    background: #FFF;\n\n  "])), theme_1.theme.UNIT(10), theme_1.theme.UNIT(6))
});
var DotStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background: ", ";\n    border-radius: 50%;\n    font-size: 0;\n    flex-shrink: 0;\n    margin-top: ", ";\n    margin-bottom: ", ";\n    width: ", ";\n    height: ", ";\n    border-color: ", ";\n\n    ", "\n  "], ["\n    background: ", ";\n    border-radius: 50%;\n    font-size: 0;\n    flex-shrink: 0;\n    margin-top: ", ";\n    margin-bottom: ", ";\n    width: ", ";\n    height: ", ";\n    border-color: ", ";\n\n    ", "\n  "])), theme_1.theme.COLOR('line-mid'), theme_1.theme.UNIT(0.5), theme_1.theme.UNIT(0.5), theme_1.theme.UNIT(1.5), theme_1.theme.UNIT(1.5), theme_1.theme.COLOR('primary'), function (props) {
    return props.isDragging && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme_1.theme.COLOR('line'));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""]))),
  Dot: styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), DotStyles)
};
My.Container = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n  &:hover ", " {\n    background-color: ", ";\n  }\n"], ["\n  ", "\n  &:hover ", " {\n    background-color: ", ";\n  }\n"])), ContainerStyles, My.Dot, theme_1.theme.COLOR('primary'));
var DragHandle = function (props) {
  var dots = props.dots,
    rest = __rest(props, ["dots"]);
  return react_1.default.createElement(My.Container, __assign({}, rest), (0, lodash_1.range)(dots).map(function (index) {
    return react_1.default.createElement(My.Dot, {
      isDragging: props.isDragging,
      key: index
    });
  }));
};
exports.DragHandle = DragHandle;
exports.DragHandle.defaultProps = exports.DragHandleDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;